import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';

import classes from './ClaimPuzzleAnimation.module.scss';
import { ClaimPuzzleRiveAnimation } from './ClaimPuzzleRiveAnimation/ClaimPuzzleRiveAnimation';

function ClaimPuzzleAnimationComponent() {
  const { puzzleStore } = useStores();
  const { claimPuzzleAnimationState } = puzzleStore;

  if (!claimPuzzleAnimationState.enable) {
    return null;
  }

  const animationKey = `${claimPuzzleAnimationState.coinType}-${claimPuzzleAnimationState.puzzleAmount}`;

  return (
    <div className={classes.claimPuzzleAnimation}>
      <ClaimPuzzleRiveAnimation
        key={animationKey}
        amount={claimPuzzleAnimationState.puzzleAmount}
        input={claimPuzzleAnimationState.coinType === 'SC' ? 'green' : 'yellow'}
        onAnimationEnd={() => {
          claimPuzzleAnimationState.onAnimationEnd?.();
        }}
      />
    </div>
  );
}

export const ClaimPuzzleAnimation = observer(ClaimPuzzleAnimationComponent);
